import { render } from "./partnerAccountsEditor.vue?vue&type=template&id=748e450f"
import script from "./partnerAccountsEditor.vue?vue&type=script&lang=js"
export * from "./partnerAccountsEditor.vue?vue&type=script&lang=js"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__